export const IconStyles = {
  small: {
    width: '12px',
    height: '12px',
  },
  medium: {
    width: '20px',
    height: '20px',
  },
}
